import Button from '@material-ui/core/Button';
import ButtonBase from '@material-ui/core/ButtonBase';
import Fade from '@material-ui/core/Fade';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { MuiThemeProvider } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import MyTable, { MyTableBody, MyTableHeader, MyTableRow, MyTableCol } from 'components/MyTable/';
import Spin from 'components/Spin';
import { theme } from 'components/Theme';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { listRecoveryMessages, updateRecoveryMessages, listProducts } from 'store/Orbita/Product/actions';

import RecoveryMessageForm from './components/RecoveryMessageForm';
import styles from './styles';

import type { DispatchProp } from 'react-redux';
interface IProps extends DispatchProp<any> {
  recoveryEmails: any;
  classes: any;
  listProducts: any;
  match: any;
}

interface IStates {
  isFetching: boolean;
  anchorEl: any;
  emailIdSelected: any;
  emailSelected: any;
  idProduct: any;
  openForm: boolean;
  editing: boolean;
  isFetchingProduct: boolean;
}

class RecoveryMessages extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isFetching: false,
      anchorEl: null,
      emailIdSelected: null,
      emailSelected: null,
      idProduct: 0,
      openForm: false,
      editing: false,
      isFetchingProduct: true,
    };
  }

  async componentDidMount() {
    const { dispatch, match } = this.props;
    const params = match.params;

    await dispatch(listProducts(false, false, true));

    const { listProducts: products } = this.props;

    if (!Array.isArray(products)) {
      this.setState({ isFetchingProduct: false, idProduct: 0 });
      return;
    }

    if (params.productId) {
      this.setState({ idProduct: params.productId });

      const result = products.find((product: any) => product.id === Number(params.productId));

      if (result) {
        this.callMoreData();
      } else {
        this.setState({ idProduct: 0 });
      }
    }

    this.setState({ isFetchingProduct: false });
  }

  handleMenuOpen = (event: any) => {
    const idSelected = event.target.getAttribute('data-email');

    this.setState({
      anchorEl: event.currentTarget,
      emailIdSelected: idSelected,
      emailSelected: this.props.recoveryEmails.find((item: any) => item.id === Number(idSelected)),
    });
  };

  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  };

  changeEmailStatus = async () => {
    this.setState({ anchorEl: null });
    await this.props.dispatch(
      updateRecoveryMessages(this.state.idProduct, this.state.emailIdSelected, {
        active: !this.state.emailSelected.active,
      })
    );
    this.callMoreData();
  };

  callMoreData = async () => {
    this.setState({ isFetching: true, openForm: false, editing: false, anchorEl: null });
    await this.props.dispatch(listRecoveryMessages(this.state.idProduct));
    this.setState({ isFetching: false });
  };

  handleCloseForm = () => {
    this.setState({ openForm: false, editing: false });
  };

  handleOpenForm = (editing: boolean) => {
    this.setState({ openForm: true, anchorEl: null, editing });
  };

  handleChangeProduct = async (e: any) => {
    await this.setState({ idProduct: e.target.value });
    this.callMoreData();
  };

  render() {
    const indexes = [
      { title: '', ordering: false },
      { title: 'Descrição', ordering: false },
      { title: 'Título', ordering: false },
      { title: 'Dias', ordering: false },
      { title: 'Envios', ordering: false },
      { title: 'Aberturas', ordering: false },
      { title: 'Cliques', ordering: false },
      { title: '', ordering: false },
    ];

    const { classes, listProducts } = this.props;

    return (
      <Fade in={true} timeout={500}>
        <MuiThemeProvider theme={theme}>
          <div className='my-title'>
            <h1>Mensagens de Recuperação de Vendas</h1>
            <p>Cadastro de mensagens enviados automaticamente no processo de recuperação de vendas</p>
          </div>
          <div className='m16'></div>
          <div
            style={{
              padding: '20px',
              backgroundColor: 'white',
              borderRadius: '4px',
              boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.2),0px 1px 1px 0px rgba(0, 0, 0, 0.14),0px 2px 1px -1px rgba(0, 0, 0, 0.12)',
            }}
          >
            <Grid container justify='space-between' spacing={2}>
              <Grid item>
                <TextField
                  placeholder={this.state.isFetchingProduct ? 'Carregando produtos...' : 'Selecione um produto'}
                  select
                  InputProps={{ fullWidth: true, disableUnderline: true, style: { fontSize: 20, color: '#192542' } }}
                  SelectProps={{ autoWidth: true, displayEmpty: true, native: true }}
                  disabled={this.state.isFetchingProduct}
                  value={this.state.idProduct}
                  onChange={this.handleChangeProduct}
                >
                  {!this.state.isFetchingProduct && !Array.isArray(listProducts) && (
                    <option key='0' value={0} disabled={true}>
                      Nenhum produto encontrado
                    </option>
                  )}
                  {!this.state.isFetchingProduct && Array.isArray(listProducts) && (
                    <option key='0' value={0} disabled={true}>
                      Selecione um produto...
                    </option>
                  )}
                  {!this.state.isFetchingProduct &&
                    Array.isArray(listProducts) &&
                    listProducts.map((product: any) => <option key={product.id} value={product.id}>{`${product.title} (${product.id})`}</option>)}
                  {this.state.isFetchingProduct && (
                    <option key='0' value={0} disabled={true}>
                      Carregando produto(s)...
                    </option>
                  )}
                </TextField>
              </Grid>
              <Grid item>
                <Button variant='contained' disabled={this.state.idProduct === 0} color='secondary' onClick={() => this.handleOpenForm(false)}>
                  <Icon style={{ fontSize: 20, marginRight: 8 }}>message</Icon>Nova mensagem
                </Button>
              </Grid>
            </Grid>
            <div className='m16'></div>
            {this.state.isFetching ? (
              <Spin />
            ) : (
              <Fragment>
                <MyTable>
                  <MyTableHeader index={indexes} />
                  <MyTableBody>
                    {this.props.recoveryEmails &&
                      this.props.recoveryEmails.length > 0 &&
                      this.props.recoveryEmails.map((email: any) => (
                        <MyTableRow key={'rvp-' + email.id}>
                          <MyTableCol screenSizes={{ xs: 12, sm: 1, md: 6, lg: 3 }}>
                            <Tooltip placement='top' title={email.active ? 'Ativo' : 'Inativo'}>
                              <div className={`${classes.tableStatus} ${email.active ? 'ativo' : 'inativo'}`} />
                            </Tooltip>
                          </MyTableCol>
                          <MyTableCol screenSizes={{ xs: 12, sm: 3, md: 6, lg: 3 }}>{email.description}</MyTableCol>
                          <MyTableCol screenSizes={{ xs: 12, sm: 3, md: 6, lg: 3 }}>{email.title ? email.title : '-'}</MyTableCol>
                          <MyTableCol screenSizes={{ xs: 3, sm: 1, md: 6, lg: 3 }}>{email.days}</MyTableCol>
                          <MyTableCol screenSizes={{ xs: 3, sm: 1, md: 6, lg: 3 }}>{email.quantity}</MyTableCol>
                          <MyTableCol screenSizes={{ xs: 3, sm: 1, md: 6, lg: 3 }}>{email.opened}</MyTableCol>
                          <MyTableCol screenSizes={{ xs: 3, sm: 1, md: 6, lg: 3 }}>{email.clicked}</MyTableCol>
                          <MyTableCol action screenSizes={{ xs: 12, sm: 1, md: 6, lg: 3 }}>
                            <ButtonBase data-email={email.id} onClick={this.handleMenuOpen}>
                              <Icon data-email={email.id}>more_horiz</Icon>
                            </ButtonBase>
                          </MyTableCol>
                        </MyTableRow>
                      ))}
                  </MyTableBody>
                </MyTable>
                <Menu id='simple-menu' anchorEl={this.state.anchorEl} open={Boolean(this.state.anchorEl)} onClose={this.handleCloseMenu}>
                  <MenuItem onClick={this.changeEmailStatus}>Ativar/Desativar</MenuItem>
                  <MenuItem onClick={() => this.handleOpenForm(true)}>Editar</MenuItem>
                </Menu>
              </Fragment>
            )}
            {this.state.openForm && (
              <RecoveryMessageForm
                open={this.state.openForm}
                handleClose={this.handleCloseForm}
                recoveryEmail={this.state.emailSelected}
                editing={this.state.editing}
                idProduct={this.state.idProduct}
                callMoreData={this.callMoreData}
              />
            )}
          </div>
        </MuiThemeProvider>
      </Fade>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    listProducts: state.orbita.Product.list,
    recoveryEmails: state.orbita.Product.listRecoveryMessages,
  };
}

export default connect(mapStateToProps)(styles(RecoveryMessages));
